import { useState, useEffect } from 'react';
import fetch from 'unfetch';
/**
 *
 * @param {*} code The code from the user to check
 * @param {*} phoneNumber The phone number to check against the database
 * @param {*} firstName first name of the user
 * @param {*} lastName the last name of the user
 * @returns status:success or status:error. This also !!IMPORTANT!! creates a temporary auth with the users
 *  phone number in a jwt. This allows us to securely verify the users ph in the database. Prevents circumvention of the auth.
 */
const verifyPartySMS = async (
	code,
	phoneNumber,
	firstName,
	lastName,
	partyToJoin
) => {
	console.log(code);
	const url = `/api/party/join/verify`;
	const res = await fetch(url, {
		method: 'POST',
		headers: {
			'content-type': 'application/json',
		},
		body: JSON.stringify({
			code: code,
			phoneNumber: phoneNumber,
			firstName: firstName,
			lastName: lastName,
			partyToJoin: partyToJoin,
		}),
	});

	if (res.ok) {
		let b = await res.json();
		console.log('RES IS', b);
		if (b.code > 0) {
			return { status: 'error' };
		} else {
			localStorage.setItem(
				'userData',
				JSON.stringify({
					data: {
						firstName: b?.firstName,
						lastName: b?.lastName,
						UUID: b?.user_id,
					},
				})
			);
			localStorage.setItem('auth', b?.jwt);

			return { status: 'success' };
		}
	} else {
		let b = await res.json();
		console.log('RES IS', b);
		return { status: 'error' };
	}
};
export default verifyPartySMS;
